// Read compatibility for evidence identifiers saved before Finance used the
// document_type catalog. This is not a selectable catalog: new types and labels
// always come from document_type, with no code change needed to add one.
const LEGACY_EVIDENCE_DOCUMENT_TYPES = {
  ClientApplicationSigned: ['application_form'], EIConsent: ['ei_consent'],
  EIVerification: ['ei_verification'],
  IndigenousIdentity: ['indigenous_declaration', 'status_card', 'letter_of_reference'],
  BandFundingConfirmationOrDenial: ['band_funding_confirmation', 'band_funding_denial', 'band_funding_decision'],
  AcceptanceLetter: ['acceptance_letter'], StatementOfAccount: ['statement_of_account'],
  TuitionStatementOrInvoice: ['statement_of_account'], FundingAgreement: ['funding_agreement'],
  SignedEftBankingForm: ['EFT_form'], CaseManagerAssessment: ['case_assessment', 'case_assessment_approved'],
  AttendanceReport: ['attendance_form'], FinancialOverview: ['financial_overview'],
  IncomeVerification: ['financial_records'], ExpenseVerification: ['financial_evidence'],
  PaidReceipt: ['receipt'], EquipmentReceipt: ['receipt'], AlternatePayeeLetter: ['alternate_payee_letter'],
  InstitutionLetter: ['institution_letter'], Quote: ['equipment_quote'],
  EmployerDutiesLetter: ['employer_duties_letter'], EmployerOfferLetterAfterSubsidy: ['employer_offer_letter_after_subsidy'],
  WagePlan: ['wage_plan'],
};
const key = value => String(value || '').trim().toLowerCase();
const legacy = new Map(Object.entries(LEGACY_EVIDENCE_DOCUMENT_TYPES).map(([name, types]) => [key(name), types]));
function documentTypesForEvidence(value) {
  const code = String(value || '').trim();
  return code ? [...(legacy.get(key(code)) || [code])] : [];
}
const evidenceTypeKey = value => key(documentTypesForEvidence(value)[0]);
const isVendorBankingEvidence = value => evidenceTypeKey(value) === 'vendor_eft_form';
const isPayeeBankingEvidence = value => ['eft_form', 'vendor_eft_form'].includes(evidenceTypeKey(value));
function requirementDocumentTypes(rule) {
  const types = Array.isArray(rule?.documentTypes) ? rule.documentTypes : documentTypesForEvidence(rule?.evidenceType);
  return [...new Map(types.filter(type => typeof type === 'string' && type.trim()).map(type => [key(type), type.trim()])).values()];
}
function canonicalDocumentRequirement(rule, catalog = []) {
  const canonical = new Map(catalog.map(type => [key(type.code ?? type.value), type.code ?? type.value]));
  const types = requirementDocumentTypes(rule).map(type => canonical.get(key(type)) || type);
  // Keep this dual-use module CommonJS in the production browser compiler.
  return Object.assign({}, rule, { evidenceType: types[0] || '' }, types.length > 1 ? { documentTypes: types } : {});
}
function documentRequirementLabel(rule, catalog = []) {
  const labels = new Map(catalog.map(type => [key(type.code ?? type.value), type.label || type.code || type.value]));
  return requirementDocumentTypes(rule).map(type => labels.get(key(type)) || type).join(' or ');
}
function evidenceSelection(selections, lineId, evidenceType) {
  const exact = `${lineId}:${evidenceType}`;
  if (Object.prototype.hasOwnProperty.call(selections, exact)) return selections[exact];
  const prefix = `${lineId}:`;
  const saved = Object.keys(selections).find(name => name.startsWith(prefix) && evidenceTypeKey(name.slice(prefix.length)) === evidenceTypeKey(evidenceType));
  return saved ? selections[saved] : undefined;
}
module.exports = { isVendorBankingEvidence, isPayeeBankingEvidence, LEGACY_EVIDENCE_DOCUMENT_TYPES, documentTypesForEvidence, evidenceTypeKey,
  requirementDocumentTypes, canonicalDocumentRequirement, documentRequirementLabel, evidenceSelection };
